module.exports = __webpack_public_path__ + "static/media/050.acd8baf4.png";